const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPod|iPhone|iPad/.test(navigator.platform);

/** Returns "⌘" on Mac, "Ctrl" on Windows/Linux */
export const modKey = isMac ? "⌘" : "Ctrl";

/** Returns "⌘K" on Mac, "Ctrl+K" on Windows */
export function modShortcut(key: string): string {
  return isMac ? `⌘${key}` : `Ctrl+${key}`;
}
